<script setup>
import Layout from "../../layouts/main.vue";
import { reactive, ref, onMounted, computed } from "vue";
import { useI18n } from "vue-i18n";
import mushroom, { Filter } from "cem-primary-api";
import toastr from "toastr";
import MethodService from "@/service/MethodService";
import { listMenu } from "@/stores/ListMenu";
const { t } = useI18n();
let _ = require("lodash");
const activeTab = ref("service_default_config");
const loadingAcceptFormUpdate = ref(false);
const ruleFormUpdateServiceHealth = ref(null);
const storeListMenu = listMenu();
const idServiceConfig = ref(null);
const idServiceGroupConfig = ref(null);

const initialFormData = () => ({
  default_chart_type: null,
  table: {
    tooltip: "",
    service_id: null,
    table_config_id: null,
    sql: "",
    sql_table_formats: [],
  },
  line_chart: {
    tooltip: "",
    service_id: null,
    table_config_id: null,
    sql: "",
    sql_table_formats: [],
  },
  bar_chart: {
    tooltip: "",
    service_id: null,
    table_config_id: null,
    sql: "",
    sql_table_formats: [],
  },
  option_link: false,
  link_info: {
    target_domain: "",
    target_type: "static",
    link: "",
    target_id: null,
    link_parameters: [
      { code: "", value: "", action: "add", codeError: "", valueError: "" },
    ],
  },
});

const dataFormService = reactive(initialFormData());
const dataFormServiceGroup = reactive(initialFormData());

const currentFormData = computed(() => {
  return activeTab.value === "service_default_config"
    ? dataFormService
    : dataFormServiceGroup;
});

const listTypeChart = ref([
  { label: "Line Chart", value: "line" },
  { label: "Bar Chart", value: "bar" },
]);

const listDichVu = ref([]);
const listTableScreen = ref([]);

const targetDomainsSelect = ref([
  { label: "Primary", value: "primary" },
  { label: "Probe", value: "probe" },
  { label: "Bras", value: "bras" },
]);

const targetTypeSelect = ref([
  { label: "Static Link", value: "static" },
  { label: "Service", value: "service" },
  { label: "Table Screen", value: "table_screen" },
  { label: "Usecase", value: "usecase" },
  { label: "Dynamic", value: "dynamic" },
]);

const listUsecase = ref([]);
const listDynamic = ref([]);

const listDefaultParam = [
  "service_id",
  "service_name",
  "start_time",
  "end_time",
];

const validateSQL = (rule, value, callback) => {
  if (!value) {
    callback(new Error(t("t_sql_required") || "Trường SQL là bắt buộc"));
  } else if (!value.includes("@table")) {
    callback(
      new Error(t("t_sql_must_contain_table") || "SQL phải chứa cụm từ @table"),
    );
  } else {
    callback();
  }
};

const validateSqlTableFormats = (rule, value, callback) => {
  if (value) {
    const textValue = Array.isArray(value) ? value.join("\n") : value;
    if (typeof textValue !== "string") {
      return callback();
    }
    const lines = textValue.split("\n");
    const invalidLine = lines.find(
      (line) => line.trim() !== "" && !line.includes("@table_name"),
    );
    if (invalidLine) {
      callback(
        new Error(
          t("t_line_must_have_table_name") ||
            "Mỗi dòng phải có cụm từ @table_name",
        ),
      );
    } else {
      callback();
    }
  } else {
    callback();
  }
};

const rules = reactive({
  default_chart_type: [
    { required: true, message: t("t_select_chart_type"), trigger: "change" },
  ],
  "table.sql": [
    { required: true, message: t("t_sql_required"), trigger: "blur" },
    { validator: validateSQL, trigger: "blur" },
  ],
  "table.table_config_id": [
    { required: true, message: t("t-select-table-config"), trigger: "change" },
  ],
  "table.sql_table_formats": [
    { validator: validateSqlTableFormats, trigger: "blur" },
  ],
  "line_chart.sql": [
    { required: true, message: t("t_sql_required"), trigger: "blur" },
    { validator: validateSQL, trigger: "blur" },
  ],
  "line_chart.table_config_id": [
    { required: true, message: t("t-select-table-config"), trigger: "change" },
  ],
  "line_chart.sql_table_formats": [
    { validator: validateSqlTableFormats, trigger: "blur" },
  ],
  "bar_chart.sql": [
    { required: true, message: t("t_sql_required"), trigger: "blur" },
    { validator: validateSQL, trigger: "blur" },
  ],
  "bar_chart.table_config_id": [
    { required: true, message: t("t-select-table-config"), trigger: "change" },
  ],
  "bar_chart.sql_table_formats": [
    { validator: validateSqlTableFormats, trigger: "blur" },
  ],
  "link_info.target_domain": [
    {
      validator: (rule, value, callback) => {
        if (currentFormData.value.option_link && !value) {
          callback(new Error(t("valid_required") || "Trường này là bắt buộc"));
        } else {
          callback();
        }
      },
      trigger: "change",
    },
  ],
  "link_info.target_type": [
    {
      validator: (rule, value, callback) => {
        if (currentFormData.value.option_link && !value) {
          callback(new Error(t("valid_required") || "Trường này là bắt buộc"));
        } else {
          callback();
        }
      },
      trigger: "change",
    },
  ],
  "link_info.link": [
    {
      validator: (rule, value, callback) => {
        if (
          currentFormData.value.option_link &&
          currentFormData.value.link_info.target_type === "static" &&
          !value
        ) {
          callback(new Error(t("valid_required") || "Trường này là bắt buộc"));
        } else {
          callback();
        }
      },
      trigger: "blur",
    },
  ],
  "link_info.target_id": [
    {
      validator: (rule, value, callback) => {
        if (
          currentFormData.value.option_link &&
          currentFormData.value.link_info.target_type !== "static" &&
          !value
        ) {
          callback(new Error(t("valid_required") || "Trường này là bắt buộc"));
        } else {
          callback();
        }
      },
      trigger: "change",
    },
  ],
});

const getListDichVu = async () => {
  try {
    const response = await mushroom.service.getAllAsync(
      {
        filters: ["type=" + localStorage.getItem("type_login")],
      },
      { enabledCache: false },
    );
    listDichVu.value = (response.result || []).map((item) => ({
      name: item.name,
      id: item.id,
    }));
  } catch (e) {
    console.error("Error fetching services:", e);
  }
};

const getListUsecase = async () => {
  try {
    const response = await mushroom.usecase.getAllAsync({
      fields: "id,name",
    });
    if (response.result) {
      response.result.forEach((item) => {
        listUsecase.value.push({
          value: item.id,
          label: item.name,
        });
      });
      storeListMenu.menuPhanCap.forEach((menuStore) => {
        listUsecase.value.forEach((usecase) => {
          if (menuStore.targetId === usecase.value)
            usecase.label = menuStore.label;
        });
      });
      listUsecase.value = _.sortBy(listUsecase.value, [
        function (o) {
          return o.label.toLowerCase();
        },
      ]);
    }
  } catch (e) {
    console.error("Có lỗi: %o", e);
  }
};

const getListMenu = async (ids) => {
  try {
    const response = await mushroom.menu.getAllAsync({
      filters: Filter.in("id", ids).build(),
    });
    if (!response.result) return;
    const list = listDynamic.value.map((item) => {
      const menu = response.result.find((x) => x.id === item.menu_id);
      if (menu) {
        return {
          id: item.id,
          menu_id: item.menu_id,
          name: menu.label,
        };
      }
    });
    listDynamic.value = list.filter((item) => item);
    storeListMenu.menuPhanCap.forEach((menuStore) => {
      listDynamic.value.forEach((dynamic) => {
        if (menuStore.targetId === dynamic.id) dynamic.name = menuStore.label;
      });
    });
    listDynamic.value = _.sortBy(listDynamic.value, [
      function (o) {
        return o.name.toLowerCase();
      },
    ]);
  } catch (e) {
    console.error("Có lỗi: %o", e);
  }
};

const getListDynamic = async () => {
  try {
    const response = await mushroom.dynamic_dashboard.getAllAsync();
    if (!response.result) return;
    listDynamic.value = response.result;
    const listMenuId = response.result
      .map((item) => item.menu_id)
      .filter((item) => item);
    if (listMenuId.length > 0) await getListMenu(listMenuId);
  } catch (e) {
    console.error("Có lỗi: %o", e);
  }
};

const getListTableScreen = async (service_id, type = null) => {
  if (type && currentFormData.value[type]) {
    currentFormData.value[type].table_config_id = null;
  }
  try {
    // let filter = Filter.eq("type", localStorage.getItem("type_login"));
    let filter = Filter.eq("type", "probe");

    if (service_id) {
      filter = Filter.and(filter, Filter.eq("service_id", service_id));
    }

    const response = await mushroom.table_config.getAllAsync(
      {
        filters: filter.build(),
      },
      { enabledCache: false },
    );
    listTableScreen.value = (response.result || []).map((item) => ({
      name: item.name,
      id: item.id,
      service_id: item.service_id,
    }));
  } catch (e) {
    console.error("Error fetching table screen:", e);
  }
};

const changeTargetDomain = (val) => {
  console.log("Target domain changed:", val);
};

const changeTargetType = (val) => {
  console.log("Target type changed:", val);
  currentFormData.value.link_info.target_id = null;
};

const validateParamCode = (row) => {
  if (!row.code) {
    row.codeError = t("valid_required") || "Vui lòng nhập giá trị";
    return false;
  }

  const alphanumeric = /^[a-zA-Z0-9]+$/;
  if (!alphanumeric.test(row.code)) {
    row.codeError = "Chỉ được nhập các ký tự: a-z, A-Z, 0-9";
    return false;
  }

  const restricted = [
    "id",
    "kpi_id",
    "kpi_code",
    "kpi_value",
    "start_date",
    "stop_date",
    "vlan_id",
    "search_key",
    "limit",
    "offset",
    "filters",
    "fields",
    "sort",
    "showFormSearch",
    "quality_levels",
    "uc_type",
    "page",
    "menu",
    "access_token",
    "pid",
    "urlPrimary",
    "url_probe",
    "url_summary",
    "nameProbe",
    "type_login",
    "sh_id",
    "sh_ids"
  ];
  if (restricted.includes(row.code)) {
    row.codeError = "Variable nằm trong danh sách hạn chế";
    return false;
  }

  const params = currentFormData.value.link_info.link_parameters;
  const count = params.filter((p) => p.code === row.code).length;
  if (count > 1) {
    row.codeError = "Không nhập trùng variable";
    return false;
  }

  row.codeError = "";
  return true;
};

const validateParamValue = (row) => {
  if (!row.value) {
    row.valueError = t("valid_required") || "Vui lòng nhập giá trị";
    return false;
  }
  row.valueError = "";
  return true;
};

const addParam = async (row) => {
  const isCodeValid = validateParamCode(row);
  const isValueValid = validateParamValue(row);

  if (isCodeValid && isValueValid) {
    row.action = "delete";
    currentFormData.value.link_info.link_parameters.push({
      code: "",
      value: "",
      action: "add",
      codeError: "",
      valueError: "",
    });
  }
};

const deleteParam = (index) => {
  currentFormData.value.link_info.link_parameters.splice(index, 1);
};

const setParams = (link, params) => {
  if (!params || params.length === 0) return link;
  const url = new URL(
    "https://test/" + (link[0] === "/" ? link.slice(1) : link),
  );
  const pathAndQuery = url.pathname + url.search;
  const hash = url.hash;
  const connector = pathAndQuery.includes("?") ? "&" : "?";

  if (link === "#") {
    return "/?" + params.join("&");
  }
  return `${pathAndQuery}${connector}${params.join("&")}${hash}`;
};

const generateLinkInfoData = async (formData) => {
  const info = formData.link_info;

  const listParam = (info.link_parameters || [])
    .filter((p) => p.action !== "add" && p.code && p.value)
    .map((p) => ({
      code: p.code.trim(),
      // value: encodeURIComponent(p.value.trim()),
      value: p.value.trim(),
    }));

  const strParams = listParam.map((p) => `${p.code}=${p.value}`);

  let baseLink = "/";
  switch (info.target_type) {
    case "static":
      baseLink = info.link || "/";
      break;
    case "service":
      baseLink = `/services/${info.target_id}`;
      break;
    case "table_screen":
      baseLink = `/table-screen/${info.target_id}`;
      break;
    case "dynamic":
      baseLink = `/dashboard/${info.target_id}`;
      break;
    case "usecase":
      if (info.target_id) {
        try {
          const res = await mushroom.usecase.findByIdAsync({
            id: info.target_id,
            fields: "code",
          });
          const code = res?.result?.code?.toLowerCase() || "unknown";
          baseLink = `/usecases/${code}/${info.target_id}`;
        } catch (e) {
          console.error("Lỗi lấy mã usecase:", e);
        }
      }
      break;
  }

  const finalLink = setParams(baseLink, strParams);

  return {
    target_domain: info.target_domain,
    target_type: info.target_type,
    target_id: info.target_type === "static" ? undefined : info.target_id,
    link_parameters: listParam.length > 0 ? listParam : [],
    link: finalLink,
  };
};

const initData = async () => {
  try {
    const [resService, resGroup] = await Promise.all([
      mushroom.system_config.listAsync({
        filters: Filter.eq("key", "service_default_config").build(),
      }),
      mushroom.system_config.listAsync({
        filters: Filter.eq("key", "service_group_default_config").build(),
      }),
    ]);

    if (resService.result && resService.result.length > 0) {
      const item = resService.result[0];
      idServiceConfig.value = item.id;
      if (item.value) {
        const parsed = JSON.parse(item.value);
        const defaults = initialFormData();
        if (parsed.link_info === null) {
          parsed.link_info = defaults.link_info;
          parsed.option_link = false;
        }

        ["table", "line_chart", "bar_chart"].forEach((key) => {
          if (parsed[key]) {
            parsed[key] = { ...defaults[key], ...parsed[key] };
            if (Array.isArray(parsed[key].sql_table_formats)) {
              parsed[key].sql_table_formats =
                parsed[key].sql_table_formats.join("\n");
            }
          }
        });

        if (parsed.link_info) {
          if (!parsed.link_info.link_parameters) {
            parsed.link_info.link_parameters = [
              ...defaults.link_info.link_parameters,
            ];
          } else {
            parsed.link_info.link_parameters.forEach((p) => {
              p.action = "delete";
              p.codeError = "";
              p.valueError = "";
            });
            const lastIndex = parsed.link_info.link_parameters.length - 1;
            if (
              lastIndex < 0 ||
              parsed.link_info.link_parameters[lastIndex].code !== ""
            ) {
              parsed.link_info.link_parameters.push({
                code: "",
                value: "",
                action: "add",
                codeError: "",
                valueError: "",
              });
            } else {
              parsed.link_info.link_parameters[lastIndex].action = "add";
            }
          }
        }

        Object.assign(dataFormService, parsed);
      }
    }

    if (resGroup.result && resGroup.result.length > 0) {
      const item = resGroup.result[0];
      idServiceGroupConfig.value = item.id;
      if (item.value) {
        const parsed = JSON.parse(item.value);
        const defaults = initialFormData();
        if (parsed.link_info === null) {
          parsed.link_info = defaults.link_info;
          parsed.option_link = false;
        }

        ["table", "line_chart", "bar_chart"].forEach((key) => {
          if (parsed[key]) {
            parsed[key] = { ...defaults[key], ...parsed[key] };
            if (Array.isArray(parsed[key].sql_table_formats)) {
              parsed[key].sql_table_formats =
                parsed[key].sql_table_formats.join("\n");
            }
          }
        });

        if (parsed.link_info) {
          if (!parsed.link_info.link_parameters) {
            parsed.link_info.link_parameters = [
              ...defaults.link_info.link_parameters,
            ];
          } else {
            parsed.link_info.link_parameters.forEach((p) => {
              p.action = "delete";
              p.codeError = "";
              p.valueError = "";
            });
            const lastIndex = parsed.link_info.link_parameters.length - 1;
            if (
              lastIndex < 0 ||
              parsed.link_info.link_parameters[lastIndex].code !== ""
            ) {
              parsed.link_info.link_parameters.push({
                code: "",
                value: "",
                action: "add",
                codeError: "",
                valueError: "",
              });
            } else {
              parsed.link_info.link_parameters[lastIndex].action = "add";
            }
          }
        }

        Object.assign(dataFormServiceGroup, parsed);
      }
    }
  } catch (e) {
    console.error("Error loading configs:", e);
  }
};

const submitFormUpdateSeviceHealth = async (formEl) => {
  if (!formEl) return;
  await formEl.validate(async (valid) => {
    if (valid) {
      loadingAcceptFormUpdate.value = true;
      try {
        const isService = activeTab.value === "service_default_config";
        const id = isService
          ? idServiceConfig.value
          : idServiceGroupConfig.value;
        const rawConfig = isService ? dataFormService : dataFormServiceGroup;
        const configData = MethodService.copyObject(rawConfig);

        ["table", "line_chart", "bar_chart"].forEach((key) => {
          if (
            configData[key] &&
            typeof configData[key].sql_table_formats === "string"
          ) {
            configData[key].sql_table_formats = configData[
              key
            ].sql_table_formats
              .split("\n")
              .filter((line) => line.trim() !== "");
          }
        });

        if (configData.link_info && configData.link_info.link_parameters) {
          configData.link_info.link_parameters =
            configData.link_info.link_parameters
              .filter((p) => p.code && p.value)
              .map(({ code, value }) => ({ code, value }));
        }

        if (!configData.option_link) {
          configData.link_info = null;
        } else {
          configData.link_info = await generateLinkInfoData(configData);
        }
        console.log("id", id, configData);
        if (id) {
          await mushroom.system_config.partialUpdateAsync({
            id: id,
            value: JSON.stringify(configData),
          });
        } else {
          const res = await mushroom.system_config.createAsync({
            key: activeTab.value,
            value: JSON.stringify(configData),
          });
          if (isService) idServiceConfig.value = res.result.id;
          else idServiceGroupConfig.value = res.result.id;
        }
        toastr.success(t("toastr_update_success"));
      } catch (e) {
        console.error("Error updating config:", e);
        toastr.error(t("toastr_update_fail"));
      } finally {
        loadingAcceptFormUpdate.value = false;
      }
    }
  });
};

const handleTabChange = (tab) => {
  activeTab.value = tab;
  if (ruleFormUpdateServiceHealth.value) {
    ruleFormUpdateServiceHealth.value.clearValidate();
  }
  currentFormData.value.link_info?.link_parameters?.forEach((p) => {
    p.codeError = "";
    p.valueError = "";
  });
};

onMounted(async () => {
  await storeListMenu.getListMenuPhanCap();
  await getListDichVu();
  await getListTableScreen();
  await initData();
  await getListUsecase();
  await getListDynamic();
});
</script>

<template>
  <Layout>
    <div class="card">
      <div class="card-body">
        <ul class="nav nav-tabs nav-tabs-custom nav-justified" role="tablist">
          <li class="nav-item">
            <a
              class="nav-link"
              :class="{ active: activeTab === 'service_default_config' }"
              @click="handleTabChange('service_default_config')"
              role="tab"
            >
              <span class="d-block d-sm-none"><i class="fas fa-cog"></i></span>
              <span class="d-none d-sm-block">{{
                $t("t_service_config")
              }}</span>
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              :class="{
                active: activeTab === 'service_group_default_config',
              }"
              @click="handleTabChange('service_group_default_config')"
              role="tab"
            >
              <span class="d-block d-sm-none"
                ><i class="fas fa-layer-group"></i
              ></span>
              <span class="d-none d-sm-block">{{
                $t("t_service_group_config")
              }}</span>
            </a>
          </li>
        </ul>

        <div class="tab-content text-muted">
          <div class="tab-pane active" role="tabpanel">
            <el-form
              ref="ruleFormUpdateServiceHealth"
              label-position="top"
              :model="currentFormData"
              status-icon
              :rules="rules"
              label-width="120px"
              class="dialog-service-health__form"
              scroll-to-error
            >
              <el-form-item
                :label="$t('t-chart-type')"
                prop="default_chart_type"
                required
              >
                <el-segmented
                  v-model="currentFormData.default_chart_type"
                  :options="listTypeChart"
                  style="width: 300px"
                />
              </el-form-item>

              <div
                class="dialog-service-health__block mb-4 border rounded p-3 bg-light"
              >
                <div class="dialog-service-health__block--title fw-bold mb-3">
                  <i class="ri-table-fill me-2 text-warning"></i
                  >{{ $t("t_config_kpi") }}
                </div>
                <b-row>
                  <b-col md="6">
                    <el-form-item :label="$t('t-select-service')">
                      <el-select
                        filterable
                        v-model="currentFormData.table.service_id"
                        :placeholder="$t('t-select-service')"
                        clearable
                        style="width: 100%"
                        @change="(val) => getListTableScreen(val, 'table')"
                      >
                        <el-option
                          v-for="item in listDichVu"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        />
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col md="6">
                    <el-form-item
                      :label="$t('t-select-table-config')"
                      prop="table.table_config_id"
                      required
                    >
                      <el-select
                        filterable
                        v-model="currentFormData.table.table_config_id"
                        :placeholder="$t('t-select-table-config')"
                        ref="table.table_config_id"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in listTableScreen"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        />
                      </el-select>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item label="SQL" prop="table.sql" required>
                  <el-input
                    ref="table.sql"
                    type="textarea"
                    :rows="5"
                    :input-style="{
                      wordBreak: 'break-word',
                    }"
                    v-model="currentFormData.table.sql"
                    :placeholder="$t('t_sql_must_have_table')"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  :label="$t('t_format_born_table')"
                  prop="table.sql_table_formats"
                >
                  <el-input
                    type="textarea"
                    :rows="5"
                    :input-style="{
                      wordBreak: 'break-word',
                    }"
                    v-model="currentFormData.table.sql_table_formats"
                    :placeholder="$t('t_line_must_have_table_name')"
                  ></el-input>
                </el-form-item>
              </div>

              <div
                class="dialog-service-health__block mb-4 border rounded p-3 bg-light"
              >
                <div class="dialog-service-health__block--title fw-bold mb-3">
                  <i class="ri-line-chart-fill me-2 text-warning"></i
                  >{{ $t("t_config_line_chart") }}
                </div>
                <b-row>
                  <b-col md="6">
                    <el-form-item :label="$t('t-select-service')">
                      <el-select
                        filterable
                        v-model="currentFormData.line_chart.service_id"
                        :placeholder="$t('t-select-service')"
                        clearable
                        style="width: 100%"
                        @change="(val) => getListTableScreen(val, 'line_chart')"
                      >
                        <el-option
                          v-for="item in listDichVu"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        />
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col md="6">
                    <el-form-item
                      :label="$t('t-select-table-config')"
                      prop="line_chart.table_config_id"
                      required
                    >
                      <el-select
                        filterable
                        v-model="currentFormData.line_chart.table_config_id"
                        :placeholder="$t('t-select-table-config')"
                        ref="line_chart.table_config_id"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in listTableScreen"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        />
                      </el-select>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item label="SQL" prop="line_chart.sql" required>
                  <el-input
                    ref="line_chart.sql"
                    type="textarea"
                    :rows="5"
                    :input-style="{
                      wordBreak: 'break-word',
                    }"
                    v-model="currentFormData.line_chart.sql"
                    :placeholder="$t('t_sql_must_have_table')"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  :label="$t('t_format_born_table')"
                  prop="line_chart.sql_table_formats"
                >
                  <el-input
                    type="textarea"
                    :rows="5"
                    :input-style="{
                      wordBreak: 'break-word',
                    }"
                    v-model="currentFormData.line_chart.sql_table_formats"
                    :placeholder="$t('t_line_must_have_table_name')"
                  ></el-input>
                </el-form-item>
              </div>

              <div
                class="dialog-service-health__block mb-4 border rounded p-3 bg-light"
              >
                <div class="dialog-service-health__block--title fw-bold mb-3">
                  <i class="ri-bar-chart-fill me-2 text-warning"></i
                  >{{ $t("t_config_bar_chart") }}
                </div>
                <b-row>
                  <b-col md="6">
                    <el-form-item :label="$t('t-select-service')">
                      <el-select
                        filterable
                        v-model="currentFormData.bar_chart.service_id"
                        :placeholder="$t('t-select-service')"
                        clearable
                        style="width: 100%"
                        @change="(val) => getListTableScreen(val, 'bar_chart')"
                      >
                        <el-option
                          v-for="item in listDichVu"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        />
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col md="6">
                    <el-form-item
                      :label="$t('t-select-table-config')"
                      prop="bar_chart.table_config_id"
                      required
                    >
                      <el-select
                        filterable
                        v-model="currentFormData.bar_chart.table_config_id"
                        :placeholder="$t('t-select-table-config')"
                        ref="bar_chart.table_config_id"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in listTableScreen"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        />
                      </el-select>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item label="SQL" prop="bar_chart.sql" required>
                  <el-input
                    ref="bar_chart.sql"
                    type="textarea"
                    :rows="5"
                    :input-style="{
                      wordBreak: 'break-word',
                    }"
                    v-model="currentFormData.bar_chart.sql"
                    :placeholder="$t('t_sql_must_have_table')"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  :label="$t('t_format_born_table')"
                  prop="bar_chart.sql_table_formats"
                >
                  <el-input
                    type="textarea"
                    :rows="5"
                    :input-style="{
                      wordBreak: 'break-word',
                    }"
                    v-model="currentFormData.bar_chart.sql_table_formats"
                    :placeholder="$t('t_line_must_have_table_name')"
                  ></el-input>
                </el-form-item>
              </div>

              <div
                class="dialog-service-health__block mb-4 border rounded p-3 bg-light"
              >
                <div
                  class="dialog-service-health__block--title option-link d-flex align-items-center justify-content-between mb-3"
                >
                  <div class="option-link__item fw-bold">
                    <i class="ri-link-m me-2 text-warning"></i
                    >{{ $t("t_config_link") }}
                  </div>
                  <div>
                    <el-checkbox
                      v-model="currentFormData.option_link"
                      :label="$t('t_link_config')"
                    />
                  </div>
                </div>
                <div v-if="currentFormData.option_link">
                  <b-row>
                    <b-col md="6">
                      <el-form-item
                        :label="$t('t-target-domains')"
                        prop="link_info.target_domain"
                        :required="currentFormData.option_link"
                      >
                        <el-select
                          v-model="currentFormData.link_info.target_domain"
                          filterable
                          :placeholder="`${$t('t-placeholder-target-domains')}`"
                          style="width: 100%"
                          :no-match-text="$t('t-match-data')"
                          :no-data-text="$t('t-no-data')"
                          @change="changeTargetDomain"
                        >
                          <el-option
                            v-for="item in targetDomainsSelect"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="6">
                      <el-form-item
                        :label="$t('t-target-type')"
                        prop="link_info.target_type"
                        :required="currentFormData.option_link"
                      >
                        <el-select
                          v-model="currentFormData.link_info.target_type"
                          filterable
                          :placeholder="`${$t('t-placeholder-target-type')}`"
                          style="width: 100%"
                          :no-match-text="$t('t-match-data')"
                          :no-data-text="$t('t-no-data')"
                          @change="changeTargetType"
                        >
                          <el-option
                            v-for="item in targetTypeSelect"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form-item>
                    </b-col>
                  </b-row>

                  <el-form-item
                    label="Link"
                    v-if="
                      currentFormData.link_info?.target_type === 'static' ||
                      currentFormData.link_info?.target_type === undefined
                    "
                    prop="link_info.link"
                    class="is-required"
                  >
                    <el-input
                      v-model="currentFormData.link_info.link"
                      :placeholder="$t('t-place-link')"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="Target"
                    prop="link_info.target_id"
                    class="is-required"
                    v-else
                  >
                    <el-select
                      filterable
                      style="width: 100%"
                      v-if="currentFormData.link_info.target_type === 'service'"
                      v-model="currentFormData.link_info.target_id"
                      :placeholder="$t('t-select-service')"
                      :no-match-text="$t('t-match-data')"
                      :no-data-text="$t('t-no-data')"
                    >
                      <el-option
                        v-for="item in listDichVu"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      />
                    </el-select>
                    <el-select
                      filterable
                      style="width: 100%"
                      v-if="
                        currentFormData.link_info.target_type === 'table_screen'
                      "
                      v-model="currentFormData.link_info.target_id"
                      :placeholder="$t('t-select-table-screen')"
                      :no-match-text="$t('t-match-data')"
                      :no-data-text="$t('t-no-data')"
                    >
                      <el-option
                        v-for="item in listTableScreen"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      />
                    </el-select>
                    <el-select
                      filterable
                      style="width: 100%"
                      v-if="currentFormData.link_info.target_type === 'usecase'"
                      v-model="currentFormData.link_info.target_id"
                      :placeholder="$t('t-select-usecase')"
                      :no-match-text="$t('t-match-data')"
                      :no-data-text="$t('t-no-data')"
                    >
                      <el-option
                        v-for="item in listUsecase"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                    <el-select
                      filterable
                      style="width: 100%"
                      v-if="currentFormData.link_info.target_type === 'dynamic'"
                      v-model="currentFormData.link_info.target_id"
                      placeholder="Chọn dynamic"
                      :no-match-text="$t('t-match-data')"
                      :no-data-text="$t('t-no-data')"
                    >
                      <el-option
                        v-for="item in listDynamic"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      />
                    </el-select>
                  </el-form-item>

                  <el-form-item
                    :label="$t('t_parameters_list')"
                    class="nguong-mau-sac mt-3"
                  >
                    <el-table
                      :data="currentFormData.link_info?.link_parameters"
                      border
                      compact
                      size="small"
                    >
                      <el-table-column
                        prop="code"
                        min-width="150"
                        align="start"
                      >
                        <template #header>
                          <div class="info-param d-flex align-items-center">
                            <span class="me-1">Variable</span>
                            <el-tooltip
                              class="box-item"
                              effect="dark"
                              placement="top-start"
                            >
                              <template #content>
                                <div style="max-width: 300px">
                                  Không nhập trùng variable <br />
                                  Chỉ được nhập các ký tự: a-z, A-Z, 0-9
                                  <br />
                                  Không nhập variable nằm trong danh sách sau:
                                  id, kpi_id, kpi_code, kpi_value, start_date,
                                  stop_date, vlan_id, search_key, limit, offset,
                                  filters, fields, sort, showFormSearch,
                                  quality_levels, uc_type, page, menu,
                                  access_token, pid, urlPrimary, nameProbe,
                                  type_login, sh_id, sh_ids
                                </div>
                              </template>
                              <i
                                class="ri-question-line text-info"
                                style="cursor: pointer"
                              ></i>
                            </el-tooltip>
                            <el-tooltip
                              class="box-item"
                              effect="dark"
                              placement="top-start"
                            >
                              <template #content>
                                {{
                                  $t("t_variations_conditions", {
                                    list: listDefaultParam.join(`, `),
                                  })
                                }}
                              </template>
                              <i
                                class="ri-info-card-line text-info ms-1"
                                style="cursor: pointer"
                              ></i>
                            </el-tooltip>
                          </div>
                        </template>
                        <template #default="scope">
                          <el-form-item :error="scope.row.codeError">
                            <el-input
                              type="text"
                              v-model="scope.row.code"
                              placeholder="Variable"
                              @input="scope.row.codeError = ''"
                            />
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="value"
                        label="Value"
                        min-width="150"
                        align="start"
                      >
                        <template #default="scope">
                          <el-form-item :error="scope.row.valueError">
                            <el-input
                              type="text"
                              v-model="scope.row.value"
                              placeholder="Value"
                              @input="scope.row.valueError = ''"
                            />
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :label="$t('t-action')"
                        align="center"
                        width="80px"
                      >
                        <template #default="scope">
                          <div class="btn-group-thao-tac">
                            <el-button
                              v-if="scope.row.action === 'add'"
                              type="primary"
                              circle
                              size="small"
                              @click="addParam(scope.row, scope.$index)"
                            >
                              <i class="ri-add-line"></i>
                            </el-button>
                            <el-button
                              v-else
                              type="danger"
                              circle
                              size="small"
                              @click="deleteParam(scope.$index)"
                            >
                              <i class="ri-delete-bin-line"></i>
                            </el-button>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-form-item>
                </div>
              </div>

              <div class="action-form text-center">
                <button
                  type="button"
                  class="btn btn-secondary btn-border"
                  :disabled="loadingAcceptFormUpdate"
                  @click="
                    submitFormUpdateSeviceHealth(ruleFormUpdateServiceHealth)
                  "
                >
                  <i
                    v-if="loadingAcceptFormUpdate"
                    class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                  ></i>
                  {{ $t("t_action_update") }}
                </button>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.tab-content {
  padding: 1rem 0 0 0;
}
.dialog-service-health__block--title {
  font-size: 16px;
  color: #495057;
}

.bg-light {
  background-color: #f8f9fa !important;
}

.info-param span {
  font-weight: 600;
}

.action-form .el-button {
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.btn-group-thao-tac {
  display: flex;
  justify-content: center;
  align-items: center;
}

:deep(.el-textarea__inner) {
  /* font-family: "Consolas", "Monaco", "Courier New", monospace; */
  font-size: 13px;
  background-color: #fcfcfc;
}

:deep(.el-form-item__label) {
  font-weight: 600;
  color: #555;
}

.nav-tabs-custom .nav-link {
  cursor: pointer;
}

/* Đảm bảo thông báo lỗi validate hiển thị được trong table cell */
:deep(.nguong-mau-sac .el-table__cell .el-form-item) {
  margin-bottom: 22px; /* Tạo khoảng trống cho thông báo lỗi */
}

:deep(.nguong-mau-sac .el-table__cell .el-form-item__error) {
  padding-top: 4px;
}

:deep(.nguong-mau-sac .el-table__cell) {
  vertical-align: top; /* Chỉnh cho nội dung nằm trên cùng để padding bên dưới đều */
}
</style>
